// Entrypoint APP
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import LRoot from './LRoot';

import MobileView from './components/library/custom/-APP_TARGET/MobileView';

const isMobile = (/Android|iPhone|iPad|Mobile|Windows Phone/i.test(navigator.userAgent));
const root = document.getElementById(`DJAPPMM`);
if (root) {
  root.oncontextmenu = () => false; // PWA requirement - Disable Default Browser Right-Click

  // Load custom config from each project and inject it to the global config
  let config = null;
  try { config = require('./config.json') } catch(e) {}

  window.DJAPPMM = ReactDOM.render(
    !isMobile
      ? <LRoot
        configuration={config}
        playerSrcHTML={root.getAttribute('playerSrcHTML')}
        playerSrcCss={root.getAttribute('playerSrcCss')}
        playerSrcJSCore={root.getAttribute('playerSrcJSCore')}
        playerSrcJSAPI={root.getAttribute('playerSrcJSAPI')}
        playerSrcJSBridge={root.getAttribute('playerSrcJSBridge')}
        playerSrcCssCustom={root.getAttribute('playerSrcCssCustom')}
        playerIDRef={root.getAttribute('playerIDRef')}
      />
      : <MobileView />
  , root);
}

serviceWorker.unregister();
